export default ({ title }) => {
  return (
    <section className="webinars_title_section">
      <div className="webinars_title_section-container section-layout">
        <div>
          <div className="webinars_title_section-text_container">
            <h1>{title}</h1>
          </div>
        </div>
      </div>
    </section>
  );
};
